import { Button, ButtonProps } from '@kontentino/ui';
import { Action, ActionProps, resolveLabel } from 'actions';
import UserPermissionGate from 'components/UserPermissionGate';
import React from 'react';

export type ActionButtonProps<TAction extends Action> = ActionProps<TAction> &
  ButtonProps;

export const ActionButton = function <TAction extends Action>({
  action,
  actionParams,
  children,
  iconBefore,
  ...props
}: ActionButtonProps<TAction>) {
  return (
    <UserPermissionGate scopes={action.scopes}>
      <Button
        onClick={() => action.perform?.(actionParams)}
        iconBefore={iconBefore ?? action.iconBefore}
        {...props}
      >
        {children ?? resolveLabel(action.label)}
      </Button>
    </UserPermissionGate>
  );
};
